import { render, staticRenderFns } from "./GenericSummaryList.vue?vue&type=template&id=759c8dc2&scoped=true"
import script from "./GenericSummaryList.vue?vue&type=script&lang=js"
export * from "./GenericSummaryList.vue?vue&type=script&lang=js"
import style0 from "./GenericSummaryList.vue?vue&type=style&index=0&id=759c8dc2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "759c8dc2",
  null
  
)

export default component.exports